import styled, { keyframes } from 'styled-components';
import { Button, Menu } from 'antd';
import { COLORS } from '../../../constants/colors';

const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
`;

export const MovableBlock = styled.div`
    width: 100%;
    margin: 16px auto;
    padding: 24px;
    background-color: white;
    border-radius: 16px;
    border: 1px solid #f0f0f0;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    animation: ${fadeIn} 0.3s ease-in-out;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    animation-delay: ${(props) => props.animationDelay || '0s'};

    &:hover {
        border-color: ${COLORS.$mainBlue}20;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .drag-handle {
        color: #bfbfbf;
        margin-right: 16px;
        cursor: move;
        transition: color 0.2s ease;
        
        &:hover {
            color: ${COLORS.$mainBlue};
        }
    }

    .block-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .block-image {
        width: ${props => props.cardType === 'highlight' ? 'auto' : '70px'};
        height: ${props => props.cardType === 'highlight' ? '70px' : '70px'};
        border-radius: 12px;
        object-fit: cover;
        margin-right: 16px;
        transition: transform 0.2s ease;
        
        &:hover {
            transform: scale(1.02);
        }
    }

    .block-header {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .block-title {
        font-size: 18px;
        font-weight: 600;
        color: #262626;
        margin: 0;
        line-height: 1.4;
    }

    .block-type-icon {
        color: #8c8c8c;
        font-size: 16px;
        transition: color 0.2s ease;

        &:hover {
            color: ${COLORS.$mainBlue};
        }
    }

    .block-visibility {
        color: ${props => props.isPublished ? '#52c41a' : '#ff4d4f'};
        margin-right: 10px;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 0.8;
        }
    }

    .block-price {
        font-size: 16px;
        color: ${COLORS.$mainBlue};
        font-weight: 500;
        margin-top: 4px;
    }
`;

export const ActionButton = styled(Button)`
    && {
        border: 1px solid #949494;
        padding: 8px;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        transition: all 0.2s ease;

        &:hover {
            background: #f5f5f5;
            color: ${COLORS.$mainBlue};
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
`;

export const StyledMenu = styled(Menu)`
    && {
        border-radius: 12px;
        border-inline-end: none !important;

        .ant-menu-item {
            border-radius: 8px;
            display: flex;
            align-items: center;
            margin: 4px 0;
            padding: 10px 12px;
            transition: all 0.2s ease;

            &:hover {
                background: #f5f5f5;
                color: ${COLORS.$mainBlue};
            }

            .anticon, .fa-icon {
                margin-right: 8px;
            }
        }
    }
`;